import Vue from "vue";
import Router from "vue-router";
import $ from "jquery";
import Home from "../components/Home.vue";
import Hello from "../components/Hello.vue";
import AboutLanShu from "../components/AboutLanShu.vue";
import LanShuDetail from "../components/AboutDetail.vue";
import Brand from "../components/Brand.vue";
import BrandLanshu from "../components/BrandLanshu.vue";
import DynamicLanshu from "../components/dynamicLanshu.vue";
import LanshuTrends from "../components/LanshuTrends.vue";
import VideoDetail from "../components/videoDetail.vue";
import NewsDetails from "../components/newsDetail.vue";
import CompanyNewsDetail from "../components/companyNewsDetail.vue";
import ProductsList from "../components/ProductsList.vue";
import Login from "../components/login.vue";
import BrandNew from "../components/brandNew.vue";
import ZhongBrand from "../components/zhongBrand.vue";
import ZhongList from "../components/zhongList.vue";
import HuaiBrand from "../components/huaiBrand.vue";
import ShuiBrand from "../components/shuiBrand.vue";
import zbqfBrand from "../components/zbqfBrand.vue";
import YiBrand from "../components/yiBrand.vue";
import ParkLanShu from "../components/ParkLanShu.vue";
import school from "../components/school.vue";

import YiBrand22 from "../components/yiBrand22.vue";
import YiYellow from "../components/yiYellow.vue";
import YiPurple from "../components/yiPurple.vue";
import YiRed from "../components/yiRed.vue";
import YiClean from "../components/yiClean.vue";
import YiWhite from "../components/yiWhite.vue";
import YiBlack from "../components/yiBlack.vue";
import YiStory from "../components/yiStory.vue";
import YiSkin from "../components/yiSkin.vue";
import YiDesign from "../components/yiDesign.vue";
import YiOld from "../components/yiOld.vue";
import YiNew from "../components/yiNew.vue";

import PutiDetail from "../components/putiDetail.vue";
import DyNewsDetail from "../components/dyNewsDetail.vue";
import mLogin from "../components/mComponents/mLogin.vue";
import lanshu from "../components/lanshuBrand.vue";

// 移动端开始
import mHome from "../components/mComponents/mhome.vue";
import mAboutLansu from "../components/mComponents/maboutLansu.vue";
import mDynamicIntroduce from "../components/mComponents/mdynamicIntroduce.vue";
import mDynamticNews from "../components/mComponents/mdynamicNews.vue";
import mBrandLansu from "../components/mComponents/mBrandLansu.vue";
import mHuaiBrand from "../components/mComponents/mhuaiBrand.vue";
import mXinBrand from "../components/mComponents/mxinBrand.vue";
import mShuiBrand from "../components/mComponents/mshuiBrand.vue";
import mYiBrand from "../components/mComponents/myiBrand.vue";
import mZhongBrand from "../components/mComponents/mzhongBrand.vue";
import mDynamticJoinus from "../components/mComponents/mdynamticJoinus.vue";
import mLansuTrends from "../components/mComponents/mLansuTrends.vue";
import mNewsDetail from "../components/mComponents/mNewsDetail.vue";
import mVideoDetail from "../components/mComponents/mVideoDetail.vue";
import mPutiDetail from "../components/mComponents/mPutiDetail.vue";
import mDyNewsDetail from "../components/mComponents/mDyNewsDetail.vue";
import mProductList from "../components/mComponents/mProductsList.vue";
import mDynamicLanshu from "../components/mComponents/mdynamicLanshu.vue";
import mlanshuBrand from "../components/mComponents/mlanshuBrand.vue";
import mzbqfBrand from "../components/mComponents/mzbqfBrand.vue";

Vue.use(Router);
// export default new Router({
// 	scrollBehavior(to, from, saveTop) {
// 		if (saveTop) {
// 			return saveTop;
// 		} else {
// 			return {
// 				x: 0,
// 				y: 0
// 			}
// 		}
// 	},
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/hello",
    name: "hello",
    component: Hello
  },
  {
    path: "/aboutlanshu",
    name: "AboutLanShu",
    component: AboutLanShu
  },
  {
    path: "/lasurDetail",
    name: "LanShuDetail",
    component: LanShuDetail
  },
  // {
  // 	path:'/brand',
  // 	name:'Brand',
  // 	component: Brand
  // },
  {
    path: "/park",
    name: "ParkLanShu",
    component: ParkLanShu
  },
  {
    path: "/school",
    name: "school",
    component: school
  },
  {
    path: "/brand",
    name: "BrandNew",
    component: BrandNew
  },
  {
    path: "/zhongBrand",
    name: "ZhongBrand",
    component: ZhongBrand
  },
  {
    path: "/zhongList",
    name: "ZhongList",
    component: ZhongList
  },
  {
    path: "/putiBrand",
    name: "PutiDetail",
    component: PutiDetail
  },
  {
    path: "/huaiBrand",
    name: "HuaiBrand",
    component: HuaiBrand
  },
  {
    path: "/lanshuBrand",
    name: "lanshu",
    component: lanshu
  },
  {
    path: "/shuiBrand",
    name: "ShuiBrand",
    component: ShuiBrand
  },
  {
    path: "/yiBrand",
    name: "YiBrand",
    component: YiBrand
  },
  //   植本清方
  {
    path: "/zbqfBrand",
    name: "zbqfBrand",
    component: zbqfBrand
  },

  // 一清堂新内容
  {
    path: "/yiBrand22",
    name: "YiBrand22",
    component: YiBrand22
  },
  {
    path: "/yiYellow",
    name: YiYellow,
    component: YiYellow
  },
  {
    path: "/yiPurple",
    name: YiPurple,
    component: YiPurple
  },
  {
    path: "/yiRed",
    name: YiRed,
    component: YiRed
  },
  {
    path: "/yiClean",
    name: YiClean,
    component: YiClean
  },

  {
    path: "/yiWhite",
    name: YiWhite,
    component: YiWhite
  },
  {
    path: "/yiBlack",
    name: YiBlack,
    component: YiBlack
  },
  {
    path: "/yiStory",
    name: YiStory,
    component: YiStory
  },
  {
    path: "/yiSkin",
    name: YiSkin,
    component: YiSkin
  },
  {
    path: "/yiDesign",
    name: YiDesign,
    component: YiDesign
  },
  {
    path: "/yiOld",
    name: YiOld,
    component: YiOld
  },
  {
    path: "/yiNew",
    name: YiNew,
    component: YiNew
  },

  {
    path: "/brandLanshu",
    name: "BrandLanshu",
    component: BrandLanshu
  },
  {
    path: "/dynamicLanshu",
    name: "DynamicLanshu",
    component: DynamicLanshu
  },
  {
    path: "/lanshuTrends",
    name: "LanshuTrends",
    component: LanshuTrends
  },
  {
    path: "/videoDetail",
    name: "VideoDetail",
    component: VideoDetail
  },
  {
    path: "/newsDetails",
    name: "NewsDetails",
    component: NewsDetails
  },
  {
    path: "/companyNewsDetail",
    name: "CompanyNewsDetail",
    component: CompanyNewsDetail
  },
  {
    path: "/dyNewsDetail",
    name: "DyNewsDetail",
    component: DyNewsDetail
  },
  {
    path: "/productsList",
    name: "ProductsList",
    component: ProductsList
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  // 移动端开始
  {
    path: "/m",
    name: "mHome",
    component: mHome
  },
  {
    path: "/maboutLansu",
    name: "mAboutLansu",
    component: mAboutLansu
  },
  {
    path: "/mdyIntroduce",
    name: "mDynamicIntroduce",
    component: mDynamicIntroduce
  },
  {
    path: "/mdyNews",
    name: "mDynamticNews",
    component: mDynamticNews
  },
  {
    path: "/mbrandLansu",
    name: "mBrandLansu",
    component: mBrandLansu
  },
  {
    path: "/mhuaibrand",
    name: "mHuaiBrand",
    component: mHuaiBrand
  },
  {
    path: "/mxinbrand",
    name: "mXinBrand",
    component: mXinBrand
  },
  {
    path: "/mshuibrand",
    name: "mShuiBrand",
    component: mShuiBrand
  },
  {
    path: "/myibrand",
    name: "mYiBrand",
    component: mYiBrand
  },
  {
    path: "/mzhongbrand",
    name: "mZhongBrand",
    component: mZhongBrand
  },
  {
    path: "/mdyjoinus",
    name: "mDynamticJoinus",
    component: mDynamticJoinus
  },
  {
    path: "/mTrends",
    name: "mLansuTrends",
    component: mLansuTrends
  },
  {
    path: "/mNewsDetail",
    name: "mNewsDetail",
    component: mNewsDetail
  },
  {
    path: "/mVideoDetail",
    name: "mVideoDetail",
    component: mVideoDetail
  },
  {
    path: "/mPutiDetail",
    name: "mPutiDetail",
    component: mPutiDetail
  },
  {
    path: "/mDyNewsDetail",
    name: "mDyNewsDetail",
    component: mDyNewsDetail
  },
  {
    path: "/mProductList",
    name: "mProductList",
    component: mProductList
  },
  {
    path: "/mDynamicLanshu",
    name: "mDynamicLanshu",
    component: mDynamicLanshu
  },
  {
    path: "/mlanshuBrand",
    name: "mlanshuBrand",
    component: mlanshuBrand
  },
  {
    path: "/mzbqfBrand",
    name: "mzbqfBrand",
    component: mzbqfBrand
  }
  // {
  // 	path: '/mLogin',
  // 	name: 'mLogin',
  // 	component: mLogin
  // }
];
// })

const router = new Router({
  mode: "history",
  routes
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js